import { Injectable } from '@angular/core';
import { CommonService } from '../../../shared/utils/common.service';
import { UtilsService } from '../../../shared/utils/utils.service';
import { Observable } from 'rxjs';
import { LogisticaDiccionario, logisticaModulo} from '../logistica-diccionario';
import { IPlanAccionRequest } from '../model/log-depuracion-pedidos.model';
import { id } from '@swimlane/ngx-datatable';
import { stream } from 'exceljs';


@Injectable({
    providedIn: 'root'
  })
  export class LogisticaService {

    urlLogistica  : string;
    diccionarioUrl: any;

    constructor(private commom: CommonService, private utilServices: UtilsService) {
      this.urlLogistica   = this.utilServices.getUrlLogistica();
      //this.urlLogistica   = "http://localhost:8080/logistica-api/v1/api/services/";
      this.diccionarioUrl = logisticaModulo.url;
    }

    // centros configurados para traslados
    getCentrosLogistica(centro: string){
      let url = this.urlLogistica + 'traslados/centro-almacen-origen/centro/'+centro;
      return this.commom.peticionGetConHeader(url);
    }

    getMuelles(idCentro: string, idAgencia: string){
      let url = this.urlLogistica + 'traslados/centro-almacen-muelle/centro-almacen-tracking/'+idCentro+'/'+idAgencia;
      return this.commom.peticionGetConHeader(url);
    }

    getTipos(){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/tipos';
      return this.commom.peticionGetConHeader(url);
    }

    /************** VIAJES ******** */
    getAllViajes(){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion;
      return this.commom.peticionGetConHeader(url);
    }

    getViajesFindAllQuery(query: string = '', page: number = 0, size: number = 10) {
      const q = encodeURIComponent(query ?? '');
      const url = `${this.urlLogistica}${this.diccionarioUrl.planificacion}/findAllQuery?page=${page}&query=${q}&size=${size}`;
      return this.commom.peticionGetConHeader(url);
    }

    getViaje(idViaje){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+"/"+idViaje;
      return this.commom.peticionGetConHeader(url);
    }

    getViajeByExcption(estados: string[] = []){
      const baseUrl = this.urlLogistica + this.diccionarioUrl.planificacion + '/by-except-status';
      const lista = Array.isArray(estados) ? estados : [];
      const query = lista
        .map(e => String(e ?? '').trim())
        .filter(e => !!e)
        .map(e => `estados=${encodeURIComponent(e)}`)
        .join('&');
      const url = query ? `${baseUrl}?${query}` : baseUrl;
      return this.commom.peticionGetConHeader(url);
    }

    searchViajesQuery(params: {
      centroDestino?: string;
      fechaFin?: string;
      fechaInicio?: string;
      proveedorId?: string;
      tipo?: string | number;
      orderDesc?: boolean;
      page?: number;
      pageSize?: number;
    }) {
      const query: string[] = [];
      const add = (key: string, value: any) => {
        if (value === undefined || value === null) return;
        const s = String(value).trim();
        if (!s) return;
        query.push(`${encodeURIComponent(key)}=${encodeURIComponent(s)}`);
      };

      add('centroDestino', params?.centroDestino);
      add('fechaFin', params?.fechaFin);
      add('fechaInicio', params?.fechaInicio);
      add('proveedorId', params?.proveedorId);
      add('tipo', params?.tipo);
      add('orderDesc', params?.orderDesc ?? true);
      add('page', params?.page ?? 0);
      add('pageSize', params?.pageSize ?? 20);

      const qs = query.length ? `?${query.join('&')}` : '';
      const url = this.urlLogistica + this.diccionarioUrl.planificacion + '/searchQuery' + qs;
      return this.commom.peticionGetConHeader(url);
    }

    getViajesByEstado(estado: String){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/estado/'+estado;
      return this.commom.peticionGetConHeader(url);
    }

    getViajesByEstadosGarita(){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/estadosgarita';
      return this.commom.peticionGetConHeader(url);
    }

    getViajesByEstadosBalanza(){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/balanza';
      return this.commom.peticionGetConHeader(url);
    }

    getViajesByEstadosAnden(){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/andenes';
      return this.commom.peticionGetConHeader(url);
    }
     
    getViajesByEstadosAndenByidUser(idUser: string){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/andenes/'+idUser;
      return this.commom.peticionGetConHeader(url);
    }

    //solo pra filtrar los estdos de revision fisica
    getViajesByEstadoRevisionFisica(){
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/revision-fisica';
      return this.commom.peticionGetConHeader(url);
    }

    getViajesByChofer() {
      const url = this.urlLogistica + this.diccionarioUrl.planificacion + '/viajesByChofer';
      return this.commom.peticionGetConHeader(url);
    }

    createViaje(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.planificacion;
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateViaje(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.planificacion;
      return this.commom.peticionPutConHeader(url, payload);
    }

    updateViajeEstado(viaje, estado, modificado) {
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/'+viaje+"/estado?estado="+estado+"&modificadoPor="+modificado;
      return this.commom.peticionPutConHeader(url, viaje);
    }

    updateNextViajeCola(area, modificado) {
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/cola/'+area+"/next/habilitar?modificadoPor="+modificado;
      return this.commom.peticionPutConHeader(url, area);
    }

    updateViajeSellosAnden(idViaje, payload) {
      console.log("payload", payload);
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+"/"+idViaje+"/sellos";
      return this.commom.peticionPostConHeader(url, payload);
    }

    deleteViaje(idViaje) {
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+'/'+idViaje;
      return this.commom.peticionDeleteConHeader(url);
    }

    preCargaViajeCsv(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+ '/csv/upload';
      return this.commom.peticionPostConHeader(url, payload);
    }

    saveCargaViajeCsv(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+ '/csv/save';
      return this.commom.peticionPostConHeader(url, payload);
    }

    /************** GARITA ******** */
    getByViajeCheckGarita(viaje :string){
      let url = this.urlLogistica + this.diccionarioUrl.check_garita+'/viaje/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    createCheckGarita(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.check_garita;
      return this.commom.peticionPostConHeader(url, payload);
    }

    createCheckGaritaFull(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.check_garita+"/full";
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateCheckGarita(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.check_garita;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteCheckGarita(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.check_garita;
      return this.commom.peticionDeleteConHeader(url, payload);
    }

    /************** REVISION VEHICULAR  ******** */
    getByViajeCheckVehicular(viaje :string) {
      let url = this.urlLogistica + this.diccionarioUrl.check_vehicular+'/viaje/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    createCheckVehicular(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.check_vehicular+"/full";
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateCheckVehicular(payload) {
            let url = this.urlLogistica + this.diccionarioUrl.check_vehicular;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteCheckVehicular(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.check_vehicular;
      return this.commom.peticionDeleteConHeader(url, payload);
    }

    /************** VIAJES BALANZA ******** */
    updateViajeBalanza(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.planificacion+"/"+payload.idViaje+"/balanza";
      return this.commom.peticionPutConHeader(url, payload);
    }

    /************** ANDENES  ******** */
    getByViajeAnden(viaje) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_anden+'/viaje/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    createAndenViaje(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_anden;
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateAndenViaje(payload) {
            let url = this.urlLogistica + this.diccionarioUrl.viaje_anden;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteAndenViaje(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_anden;
      return this.commom.peticionDeleteConHeader(url, payload);
    }

    /************** ACTIVIDADES  ******** */
    getByViajeActividad(viaje) {
      let url = this.urlLogistica + this.diccionarioUrl.actividades+'/viaje/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    createActividadesColaboradores(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.actividades+"/list";
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateActividadColaboradores(payload) {
            let url = this.urlLogistica + this.diccionarioUrl.actividades;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteActividadColaboradores(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.actividades;
      return this.commom.peticionDeleteConHeader(url, payload);
    }

    /************** VIAJE CARGA ******** */
    getByViajeCarga(viaje) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_carga+'/viaje/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    createViajeCarga(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_carga;
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateViajeCarga(payload) {
            let url = this.urlLogistica + this.diccionarioUrl.viaje_carga;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteViajeCarga(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_carga;
      return this.commom.peticionDeleteConHeader(url, payload);
    }

    /************** VIAJE DOCUMENTOS ******** */
    getFleteDataSap(viaje) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_documentos+'/flete-sap/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

     getFleteSapDetail(viaje) {
      let url = this.urlLogistica +'fletes-sap/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    getFleteFamiliaDataSap(viaje) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_documentos+'/flete-sap/familia/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    getByViajeDocumentos(viaje) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_documentos+'/viaje/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    createViajeDocumentos(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_documentos;
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateViajeDocumentos(payload) {
            let url = this.urlLogistica + this.diccionarioUrl.viaje_documentos;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteViajeDocumentos(viaje, fleteSap) {
      let data = [];
      let url = this.urlLogistica + this.diccionarioUrl.viaje_documentos+"/"+viaje+"/"+fleteSap;
      return this.commom.peticionDeleteConHeader(url);
    }

    /************** CONVOY ******** */
    getConvoy() {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy;
      return this.commom.peticionGetConHeader(url);
    }
    //Feat T.42031 Mod Logistica, /logistica/convoy 7.3
    getConvoyByEstado(estado:string) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+'/estado/'+estado;
      return this.commom.peticionGetConHeader(url);
    }

    getConvoyByEstadoViaje(estado:string) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+'/estado-viaje/'+estado;
      return this.commom.peticionGetConHeader(url);
    }

    getByConvoy(viaje) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+'/viaje/'+viaje;
      return this.commom.peticionGetConHeader(url);
    }

    createConvoy(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy;
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateConvoy(payload) {
            let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy;
      return this.commom.peticionPutConHeader(url, payload);
    }

    updateConvoyCabecera(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+'/cabecera';
      return this.commom.peticionPutConHeader(url, payload);
    }

    updateViajesByConvoy(convoyId: number, nuevoEstado: string, modificadoPor: string) {
      let url = this.urlLogistica + 'tracking-convoy-detalle/convoy/' + convoyId + '/estado?nuevoEstado=' + nuevoEstado + '&modificadoPor=' + modificadoPor;
      return this.commom.peticionPutConHeader(url, null);
    }

    deleteConvoy(viaje, fleteSap) {
      let data = [];
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+"/"+viaje+"/"+fleteSap;
      return this.commom.peticionDeleteConHeader(url);
    }

    createConvoyDetalle(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+'-detalle';
      return this.commom.peticionPostConHeader(url, payload);
    }

    deleteConvoyDetalle(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+'-detalle';
      return this.commom.peticionDeleteConHeader(url, payload);
    }

    getByConvoyDetalleViaje(idViaje) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+'-detalle'+'/viaje/'+idViaje;
      return this.commom.peticionGetConHeader(url);
    }

    cerrarConvoy(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.viaje_convoy+'/cierre';
      return this.commom.peticionPutConHeader(url, payload);
    }

    enviarMailsConvoy( idConvoy: any) {
      const url = this.urlLogistica + '/mail/convoy/' + idConvoy;
      return this.commom.peticionPostConHeader(url,"");
    }

    getFurgonesDisponibles( idproveedorTransporte: String) {
      const url = this.urlLogistica + 'tracking-convoy-detalle/furgonDisponibles/'+idproveedorTransporte;
      return this.commom.peticionGetConHeader(url);
    }

    getChoferesDisponibles( idproveedorTransporte: String) {
      const url = this.urlLogistica + 'tracking-convoy-detalle/choferDisponibles/'+idproveedorTransporte;
      return this.commom.peticionGetConHeader(url);
    }

    /************** BITACORA DE ACCIONES ******** */
    getBitacora() {
      let url = this.urlLogistica + this.diccionarioUrl.bitacora;
      return this.commom.peticionGetConHeader(url);
    }

    getBitacoraByViaje(idviaje) {
      let url = this.urlLogistica + this.diccionarioUrl.bitacora+"/viaje/"+idviaje;
      return this.commom.peticionGetConHeader(url);
    }

    /************** PREGUNTAS Y RESPUESTAS CHECK DINAMICOS ******** */
    getCheckByRegistroModulo(registro: string, modulo: string) {
      let pathParam = "/codigo/"+registro+"/modulo/"+modulo
      let url = this.urlLogistica + this.diccionarioUrl.preguntas+pathParam;
      return this.commom.peticionGetConHeader(url);
    }

    getCheckByRespuestas(idViaje: number) {
      let url = this.urlLogistica + this.diccionarioUrl.respuestas+"/viaje/"+idViaje;
      return this.commom.peticionGetConHeader(url);
    }

    createCheckByRespuestas(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.respuestas;
      return this.commom.peticionPostConHeader(url, payload);
    }

    createCheckByRespuestasListMultipart(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.respuestas+'/listmultipart';
      return this.commom.peticionPostConHeader(url, payload);
    }

    createCheckByRespuestasList(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.respuestas+'/list';
      return this.commom.peticionPostConHeader(url, payload);
    }

    getCheckRecurrente(idViaje: number) {
      let url = this.urlLogistica + this.diccionarioUrl.respuestas+"/"+idViaje+"/checkRecurrente";
      return this.commom.peticionGetConHeader(url);
    }

    getPlacas(idTransportista: string) {
      let url = this.urlLogistica + 'placas/idTransportista/' + idTransportista;
      return this.commom.peticionGetConHeader(url);
    }

    saveCheckRecurrente(payload) {
      let url = this.urlLogistica + this.diccionarioUrl.respuestas+"/recurrentes";
      return this.commom.peticionPostConHeader(url, payload);
    }

    /** MARQUESINAS */
    getMarquesinas() {
      const url = this.urlLogistica + this.diccionarioUrl.marquesinas;
      return this.commom.peticionGetConHeader(url);
    }

    createMarquesina(payload) {
      const url = this.urlLogistica + this.diccionarioUrl.marquesinas;
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateMarquesina(payload) {
      const url = this.urlLogistica + this.diccionarioUrl.marquesinas+"/"+payload.id;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteMarquesina(id) {
      const url = this.urlLogistica + this.diccionarioUrl.marquesinas+"/"+id;
      return this.commom.peticionDeleteConHeader(url);
    }

    /** MARQUESINAS MENSAJES */
    getMarquesinaMensajes() {
      const url = this.urlLogistica + this.diccionarioUrl.MarquesinaMsj;
      return this.commom.peticionGetConHeader(url);
    }

    getMensajesbyMarquesina(idMarquesina: String) {
      const url = this.urlLogistica + this.diccionarioUrl.MarquesinaMsj+"/by-marquesina/"+idMarquesina;
      return this.commom.peticionGetConHeader(url);
    }

    createMarquesinaMensajes(payload) {
      const url = this.urlLogistica + this.diccionarioUrl.MarquesinaMsj;
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateMarquesinaMensajes(payload) {
      const url = this.urlLogistica + this.diccionarioUrl.MarquesinaMsj+"/"+payload.id;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteMarquesinaMensajes(id) {
      const url = this.urlLogistica + this.diccionarioUrl.MarquesinaMsj+"/"+id;
      return this.commom.peticionDeleteConHeader(url);
    }

    //get cofiguracionTrasladosAlmacenOrigen por idTraslado
    getConfigTrasladosCentroOrigen(idUser: string) {
      let url = this.urlLogistica + "traslados/usuario-centro-almacen/usuarioCentro/"+idUser;
      return this.commom.peticionGetConHeader(url);
    }

    getConfigTrasladosAlmacenOrigen(idUser: string, idCentro: string) {
      let url = this.urlLogistica + "traslados/usuario-centro-almacen/centroAlmacen/"+idUser+"/"+idCentro;
      return this.commom.peticionGetConHeader(url);
    }

    /** PARÁMETROS DE LOGÍSTICA */
    getParametrosLogistica(idParametro: any) {
      const url = this.urlLogistica + this.diccionarioUrl.parametros + "/buscar/" + idParametro;
      return this.commom.peticionGetConHeader(url);
    }

    getParametrosLogisticaName(idParametro: any) {
      const url = this.urlLogistica + this.diccionarioUrl.parametros + "/nombre/" + idParametro;
      return this.commom.peticionGetConHeader(url);
    }

    getParametrosLogisticaNameByConvoy(idParametro: any) {
      const url = this.urlLogistica + this.diccionarioUrl.parametros + "/nombreByConvoy/" + idParametro;
      return this.commom.peticionGetConHeader(url);
    }

    createParametroLogistica(payload: any) {
      const url = this.urlLogistica + this.diccionarioUrl.parametros;
      return this.commom.peticionPostConHeader(url, payload);
    }

    updateParametroLogistica(idParametro: any, payload: any) {
      const url = this.urlLogistica + this.diccionarioUrl.parametros + "/" + idParametro;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteParametroLogistica(idParametro: any) {
      const url = this.urlLogistica + this.diccionarioUrl.parametros + "/" + idParametro;
      return this.commom.peticionDeleteConHeader(url);
    }

    downloadReporteSalida(idViaje: string | number, user: string): Observable<Blob> {
      const url = this.urlLogistica + 'reportes/salida/' + encodeURIComponent(String(idViaje)) + '/' + encodeURIComponent(user);
      return this.commom.downloadReportePDF(url);
    }

    downloadReportesPdfMasivo(ids: Array<string | number>): Observable<Blob> {
      const url = this.urlLogistica + 'reportes/pdf/masivo';
      return this.commom.downloadReporteBlobPost(url, { ids });
    }

    /************** DEPURACION DE PEDIDOS ******** */
    getDepuracionActivos(query: string = '') {
      const url = `${this.urlLogistica}${this.diccionarioUrl.depuracion}/activos?query=${encodeURIComponent(query ?? '')}`;
      return this.commom.peticionGetConHeader(url);
    }

    getDepuracionEstados() {
      const url = `${this.urlLogistica}${this.diccionarioUrl.depuracion}/estados`;
      return this.commom.peticionGetConHeader(url);
    }

    getDepuracionByEstado(estado: string, query: string = '') {
      const url = `${this.urlLogistica}${this.diccionarioUrl.depuracion}/estados/${encodeURIComponent(estado)}?query=${encodeURIComponent(query ?? '')}`;
      return this.commom.peticionGetConHeader(url);
    }

    updateDepuracionPlanAccion(id: number, payload: IPlanAccionRequest) {
      const url = `${this.urlLogistica}${this.diccionarioUrl.depuracion}/${id}/plan-accion`;
      return this.commom.peticionPutConHeader(url, payload);
    }

    cargaMasivaDepuracion(payload: FormData) {
      const url = `${this.urlLogistica}${this.diccionarioUrl.depuracion}/carga-masiva`;
      return this.commom.peticionPostConHeader(url, payload);
    }

    exportarDepuracion(query: string = '', soloActivos: boolean = true): Observable<Blob> {
      const url = `${this.urlLogistica}${this.diccionarioUrl.depuracion}/exportar?query=${encodeURIComponent(query ?? '')}&soloActivos=${soloActivos}`;
      return this.commom.downloadReportePDF(url);
    }



  }
